import { Pipe, PipeTransform } from '@angular/core';

import { MccItem } from '@shared/models';

@Pipe({
  name: 'mccDisplay',
  standalone: true,
})
export class MccDisplayPipe implements PipeTransform {
  transform(mccCodes?: string[] | null, mccItems?: MccItem[] | null): string {
    if (!mccCodes || !mccItems || mccCodes.length === 0) {
      return '';
    }

    const sortedCodes = [...mccCodes].sort((a, b) => parseInt(a) - parseInt(b));

    const displayValues = sortedCodes
      .map((code) => {
        const mccItem = mccItems.find((item) => item.value === code);
        return mccItem ? mccItem.label : `${code}: Unknown`;
      })
      .filter(Boolean);

    return displayValues.join(', ');
  }
}
